import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const ForgotPassword = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p>Please provide your email address to reset your password</p>

        <form className="form">
          <div className="control_group">
            <label htmlFor="email">Email Address</label>
            <TextField
              id="email"
              name="email"
              type="email"
              placeholder="Enter Email Address"
              fullWidth
              variant="outlined"
              margin="normal"
            />
          </div>

          <div className="form_btn">
            <Button
              className="btn btn_primary w_100"
              onClick={() => navigate("/otp")}
            >
              Submit
            </Button>
          </div>
        </form>

        <div className="auth_bottom">
          <p>
            <button
              type="button"
              className="link"
              onClick={() => navigate("/")}
            >
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
